module.exports = __webpack_public_path__ + "static/media/icn_discover_big.a1cc7582.svg";